// extracted by mini-css-extract-plugin
module.exports = {"titleIcon":"ViewChargeAffirm_titleIcon__1ydO7","inputPhoneContainer":"ViewChargeAffirm_inputPhoneContainer__3RRn1"};